import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import Spinner from '../ui/Spinner';
import ProgressBar from '../ui/ProgressBar';

const MESSAGES = [
  'Warming up the model…',
  'Composing the latent space…',
  'Rendering your idea…',
  'Adding the finishing touches…',
];

/** Animated progress state shown during AI generation (with elapsed time). */
export default function GenerationProgress({ elapsed = 0, label = 'Generating' }) {
  const [msgIdx, setMsgIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setMsgIdx((i) => (i + 1) % MESSAGES.length), 2600);
    return () => clearInterval(id);
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex flex-col items-center justify-center gap-4 py-12"
    >
      <Spinner size={40} />
      <div className="text-center">
        <p className="font-medium text-content">
          {label} · <span className="font-mono tabular-nums">{elapsed.toFixed(1)}s</span>
        </p>
        <motion.p
          key={msgIdx}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className="mt-1 text-sm text-content-muted"
        >
          {MESSAGES[msgIdx]}
        </motion.p>
      </div>
      <ProgressBar indeterminate className="max-w-xs" />
    </motion.div>
  );
}
